import { render, staticRenderFns } from "./BaseNotification.vue?vue&type=template&id=d1c0ddee&scoped=true&"
import script from "./BaseNotification.vue?vue&type=script&lang=js&"
export * from "./BaseNotification.vue?vue&type=script&lang=js&"
import style0 from "./BaseNotification.vue?vue&type=style&index=0&id=d1c0ddee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c0ddee",
  null
  
)

export default component.exports